import { render, staticRenderFns } from "./Creative.vue?vue&type=template&id=9b20cd46&scoped=true"
import script from "./Creative.vue?vue&type=script&lang=js"
export * from "./Creative.vue?vue&type=script&lang=js"
import style0 from "./Creative.vue?vue&type=style&index=0&id=9b20cd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b20cd46",
  null
  
)

export default component.exports